
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

const Sentry = require('@sentry/browser');
Sentry.init({ dsn: process.env.MIX_SENTRY_JS_DSN });

require('./bootstrap');

//require('../../../vendor/bootstrap-formhelpers/dist/js/bootstrap-formhelpers.js');
// require('../../../vendor/jquery-validation/dist/jquery.validate.min.js');
require('../../../public/js/jquery.validate.min.js');
require('../../../public/js/jquery.validate.ext.js');
require('bootstrap-select');
require('../../../node_modules/purify/lib/purify.js');
require('../../../node_modules/bootstrap-fileinput/js/fileinput.min.js');
require('../../../node_modules/chart.js/dist/Chart.min.js');
require('../../../public/js/scrolling-nav.js');
require('../../../public/js/custom.js');


